import { SESSION } from './session.actions';

const INITIAL_STATE = {};

export function SessionReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case SESSION.SET:
      return payload;
    case SESSION.CLEAR:
      return {};
    default:
      return state;
  }
}
